module.exports = __webpack_public_path__ + "static/media/mobile_team_2x.7db51a64.png";